// Mock data generator for transactions
const generateMockTransactions = (count = 2000) => {
  const transactions = [];

  // Sample data arrays for variation
  const platforms = [
    { id: "GOF", name: "GoFood" },
    { id: "GBF", name: "GrabFood" },
    { id: "SFD", name: "ShopeeFood" },
    { id: "TOF", name: "TokopediaFood" },
    null, // Some transactions don't have platform
  ];

  const types = [
    { id: "ECO", name: "E-Commerce" },
    { id: "MAN", name: "Manual" },
    { id: "SET", name: "Settle Preorder" },
    { id: "PRE", name: "Preorder" },
    { id: "DIN", name: "Dine In" },
    { id: "TOG", name: "Take Away" },
  ];

  const outlets = [
    { id: 1, name: "Main Store (Jakarta)" },
    { id: 2, name: "HO (Jakarta)" },
    { id: 3, name: "Bandung Branch" },
    { id: 4, name: "Surabaya Branch" },
    { id: 5, name: "Medan Branch" },
  ];

  const customers = [
    null, // Many transactions don't have customers
    { id: 1, name: "Dr. Tracey Streich Jr.", loyalty_point: 22 },
    { id: 2, name: "John Doe", loyalty_point: 156 },
    { id: 3, name: "Jane Smith", loyalty_point: 89 },
    { id: 4, name: "Michael Johnson", loyalty_point: 45 },
    { id: 5, name: "Sarah Wilson", loyalty_point: 203 },
  ];

  const products = [
    {
      id: 15,
      model: "App\\Models\\Inventory",
      name: "Bika Ambon - Bika Ambon Bulat",
      basePrice: 150000,
    },
    {
      id: 4,
      model: "App\\Models\\Inventory",
      name: "Bika Ambon - Bika Ambon Kotak",
      basePrice: 150000,
    },
    {
      id: 3,
      model: "App\\Models\\Product",
      name: "Brownies Bulat",
      basePrice: 120000,
    },
    {
      id: 7,
      model: "App\\Models\\Product",
      name: "Brownies Kotak",
      basePrice: 130000,
    },
    {
      id: 8,
      model: "App\\Models\\Inventory",
      name: "Kue Lapis Legit",
      basePrice: 200000,
    },
    {
      id: 9,
      model: "App\\Models\\Inventory",
      name: "Donat Special",
      basePrice: 25000,
    },
    {
      id: 10,
      model: "App\\Models\\Product",
      name: "Roti Bakar",
      basePrice: 35000,
    },
    {
      id: 11,
      model: "App\\Models\\Product",
      name: "Es Krim Vanilla",
      basePrice: 45000,
    },
  ];

  const statuses = [
    { id: "done", name: "Selesai" },
    { id: "pending", name: "Menunggu" },
    { id: "cancelled", name: "Dibatalkan" },
    { id: "processing", name: "Diproses" },
  ];

  const paymentTypes = [
    { id: "CSH", name: "Cash" },
    { id: "DEB", name: "Debit Card" },
    { id: "CC", name: "Credit Card" },
    { id: "QRS", name: "QRIS" },
    { id: "OVO", name: "OVO" },
    { id: "GDP", name: "GoPay" },
    null, // Some payments don't have type
  ];

  const taxes = [
    { id: 1, name: "PPN", value: "10.00" },
    { id: 2, name: "Service Charge", value: "5.00" },
  ];

  // Helper functions
  const getRandomItem = (array) =>
    array[Math.floor(Math.random() * array.length)];
  const getRandomNumber = (min, max) =>
    Math.floor(Math.random() * (max - min + 1)) + min;
  const getRandomDecimal = (min, max) => Math.random() * (max - min) + min;

  const generateInvoiceNumber = (index, date, outlet, type) => {
    const dateStr = date.toISOString().slice(0, 10).replace(/-/g, "").slice(2); // YYMMDD
    return `INV/${dateStr}/${outlet.id}/${type.id}/${index + 1}`;
  };

  const generateDate = (daysBack = 30) => {
    const now = new Date();
    const pastDate = new Date(
      now.getTime() - Math.random() * daysBack * 24 * 60 * 60 * 1000
    );
    return pastDate;
  };

  // Generate transactions
  for (let i = 0; i < count; i++) {
    const outlet = getRandomItem(outlets);
    const type = getRandomItem(types);
    const platform = type.id === "ECO" ? getRandomItem(platforms) : null;
    const customer =
      Math.random() < 0.3
        ? getRandomItem(customers.filter((c) => c !== null))
        : null;
    const createdAt = generateDate(60); // Within last 60 days

    // Generate items (1-5 items per transaction)
    const itemCount = getRandomNumber(1, 5);
    const items = [];
    let grossTotal = 0;

    for (let j = 0; j < itemCount; j++) {
      const product = getRandomItem(products);
      const quantity = getRandomNumber(1, 3);
      const priceVariation = getRandomDecimal(0.9, 1.1); // ±10% price variation
      const price = Math.round(product.basePrice * priceVariation);
      const amount = price * quantity;

      items.push({
        id: product.id,
        model: product.model,
        name: product.name,
        expire: getRandomNumber(0, 2),
        quantity: quantity,
        price: price,
        amount: amount,
      });

      grossTotal += amount;
    }

    // Generate taxes (sometimes)
    const transactionTaxes = [];
    let taxAmount = 0;
    if (Math.random() < 0.4) {
      // 40% chance of having taxes
      const tax = getRandomItem(taxes);
      const taxValue = parseFloat(tax.value);
      const calculatedTaxAmount = Math.round(grossTotal * (taxValue / 100));
      transactionTaxes.push({
        id: tax.id,
        name: tax.name,
        value: tax.value,
        amount: calculatedTaxAmount,
      });
      taxAmount = calculatedTaxAmount;
    }

    const subtotal = grossTotal;
    const discount = Math.random() < 0.2 ? getRandomNumber(5000, 50000) : 0; // 20% chance of discount
    const net = grossTotal - discount;
    const total = net + taxAmount;
    const rounding = Math.random() < 0.1 ? getRandomNumber(-2, 2) * 1000 : 0; // Small rounding adjustments

    // Generate payments
    const payments = [];
    const paymentCount = getRandomNumber(1, 3);
    let remainingAmount = total;
    let totalChange = 0;

    for (let p = 0; p < paymentCount; p++) {
      const isLastPayment = p === paymentCount - 1;
      const paymentAmount = isLastPayment
        ? remainingAmount + getRandomNumber(0, 20000) // Last payment might include change
        : Math.min(remainingAmount, getRandomNumber(10000, 100000));

      const changeAmount =
        isLastPayment && paymentAmount > remainingAmount
          ? paymentAmount - remainingAmount
          : 0;

      payments.push({
        amount: paymentAmount,
        change_amount: changeAmount,
        type: getRandomItem(paymentTypes),
      });

      remainingAmount -= paymentAmount - changeAmount;
      totalChange += changeAmount;
    }

    // Generate reference for settlement transactions
    let reference = null;
    if (type.id === "SET") {
      const refId = getRandomNumber(1, 1000);
      reference = {
        id: refId,
        inv: `INV/${createdAt
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "")
          .slice(2)}/${outlet.id}/PRE/${refId}`,
        gross: grossTotal,
        discount: discount,
        net: net,
        subtotal: subtotal,
        total: total,
        total_unpaid: 0,
      };
    }

    // Generate loyalty points
    const loyaltyPoint = customer
      ? {
          before: customer.loyalty_point,
          after: customer.loyalty_point + Math.round(total / 10000), // 1 point per 10k spent
        }
      : {
          before: null,
          after: 0,
        };

    const transaction = {
      inv: generateInvoiceNumber(i, createdAt, outlet, type),
      customer: customer,
      platform: platform,
      type: type,
      outlet: outlet,
      total: total,
      reference: reference,
      items: items,
      taxes: transactionTaxes,
      remark: Math.random() < 0.1 ? "Special request from customer" : null,
      status: getRandomItem(statuses),
      coupon:
        Math.random() < 0.05
          ? { id: 1, code: "DISCOUNT10", amount: discount }
          : null,
      created_at: createdAt.toISOString(),
      spv: Math.random() < 0.1 ? { id: 1, name: "Supervisor Name" } : null,
      rounding: rounding,
      payments: payments,
      gross: grossTotal,
      discount: discount,
      net: net,
      subtotal: subtotal,
      loyalty_point: loyaltyPoint,
    };

    transactions.push(transaction);
  }

  // Sort transactions by created_at descending (newest first)
  transactions.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  return transactions;
};

// Generate the mock data once and export it
export const mockTransactions = generateMockTransactions(2000);

// Function to get paginated transactions
export const getPaginatedTransactions = ({
  page = 1,
  pageSize = 10,
  startDate,
  endDate,
  outlet,
  type,
  sort,
}) => {
  let filteredTransactions = [...mockTransactions];

  // Apply filters
  if (startDate) {
    filteredTransactions = filteredTransactions.filter(
      (t) => new Date(t.created_at) >= new Date(startDate)
    );
  }

  if (endDate) {
    filteredTransactions = filteredTransactions.filter(
      (t) => new Date(t.created_at) <= new Date(endDate)
    );
  }

  if (outlet) {
    filteredTransactions = filteredTransactions.filter(
      (t) => t.outlet.id.toString() === outlet.toString()
    );
  }

  if (type) {
    filteredTransactions = filteredTransactions.filter(
      (t) => t.type.id === type
    );
  }

  // Apply sorting
  if (sort === "ascend") {
    filteredTransactions.sort(
      (a, b) => new Date(a.created_at) - new Date(b.created_at)
    );
  } else if (sort === "descend") {
    filteredTransactions.sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
  }

  const total = filteredTransactions.length;
  const lastPage = Math.ceil(total / pageSize);
  const startIndex = (page - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedData = filteredTransactions.slice(startIndex, endIndex);

  const baseUrl = "https://api.staging.ricarico.co.id/v1/trx";
  const buildUrl = (pageNum) => `${baseUrl}?page=${pageNum}`;

  return {
    status: 200,
    data: {
      current_page: page,
      data: paginatedData,
      first_page_url: buildUrl(1),
      from: startIndex + 1,
      last_page: lastPage,
      last_page_url: buildUrl(lastPage),
      links: [
        {
          url: page > 1 ? buildUrl(page - 1) : null,
          label: "&laquo; Sebelumnya",
          active: false,
        },
        ...Array.from({ length: Math.min(5, lastPage) }, (_, i) => ({
          url: buildUrl(i + 1),
          label: (i + 1).toString(),
          active: i + 1 === page,
        })),
        {
          url: page < lastPage ? buildUrl(page + 1) : null,
          label: "Berikutnya &raquo;",
          active: false,
        },
      ],
      next_page_url: page < lastPage ? buildUrl(page + 1) : null,
      path: baseUrl,
      per_page: pageSize,
      prev_page_url: page > 1 ? buildUrl(page - 1) : null,
      to: Math.min(endIndex, total),
      total: total,
    },
  };
};

// Function to get transaction detail by invoice number
export const getTransactionDetail = (inv) => {
  const transaction = mockTransactions.find((t) => t.inv === inv);

  if (transaction) {
    return {
      status: 200,
      data: transaction,
    };
  } else {
    return {
      status: 404,
      message: "Transaction not found",
    };
  }
};
